export default class HudState {
  huds = [];
  hud = { id: 0 };
  statisticDefinitions = {};
  statisticTranslations = {};
}
